import EStyleSheet from "react-native-extended-stylesheet";

export const styles = EStyleSheet.create({
  container: {
    margin: 10,
    flexDirection: "row",
  },
  country: {
    width: "8vmin",
    height: "10vmin",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: "$input_placeholder",
  },
  flag: {
    width: "5vmin",
    height: "5vmin",
  },
  caret: {
    marginHorizontal: 5,
    color: "$input_text",
  },
  picker: {
    height: "10vmin",
    width: "10vmin",
    opacity: 0,
    position: "absolute",
  },
  pickerItem: {
    opacity: 0.3,
    backgroundColor: "grey",
  },
  placeholder: {
    color: "$input_placeholder",
  },
  textField: {
    width: "28vmin",
    height: "10vmin",
    padding: 10,
    fontSize: "$input_text_size",
    fontFamily: "$input_text_style",
    color: "black",
    backgroundColor: "$input_background",
  },
  dialCode: {
    fontSize: "$dial_code_text_size",
    fontFamily: "$dial_code_text_style",
    color: "$input_text",
    opacity: 1,
  },
  icon: {
    height: "10vmin",
    width: "10vmin",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "$input_background",
  },
  invalid: {
    backgroundColor: "$invalid",
  },
  valid: {
    backgroundColor: "$valid",
  },
});
